let reloadInProgress = false;

export const isSuperOpsReauthReloadInProgress = (): boolean => reloadInProgress;

export const markSuperOpsReauthReloadInProgress = (): void => {
	reloadInProgress = true;
};
